import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPortalFAQLink]',
  standalone: false,
})
export class PortalFAQLinkDirective {
  @HostListener('click')
  onClick(): void {
    window.open('https://customersupport.techspert.com/support/home', '_blank');
  }
}
